import { Box } from "@mui/material"

export const BoxDefault = ({children, ...rest}) => {
    return <Box {...rest} >{children}</Box>
}